import moment from "moment";
import { isDateInRange } from "../../../helper/dateTimeHelper";

export const filterRequestsByRangeDate = (
  requests: Array<any>,
  rangeDate: null | [moment.Moment, moment.Moment]
) => {
  return requests.filter((req) => {
    if (rangeDate) {
      return isDateInRange(
        moment(req.createdDateTime),
        rangeDate[0].startOf("day"),
        rangeDate[1].endOf("day")
      );
    }
    return true;
  });
};

export const filterCoursesByRangeDate = (
  requests: Array<any>,
  rangeDate: null | [moment.Moment, moment.Moment]
) => {
  return requests.filter((req) => {
    if (rangeDate) {
      return isDateInRange(
        moment(req.eCourseDate),
        rangeDate[0].startOf("day"),
        rangeDate[1].endOf("day")
      ) && isDateInRange(
        moment(req.eCourseDateEnd),
        rangeDate[0].startOf("day"),
        rangeDate[1].endOf("day")
      );
    }
    return true;
  });
};


export const filterCoursesByDepartmentCode = (
  requests: Array<any>,
 departmentCode:string
) => {

  if (departmentCode === "DAD") {
    return requests.filter((req) =>
      req.eDepartment.toLowerCase().includes("đà nẵng")
    );
  }
  if(departmentCode === "NBA"){
    return requests.filter((req) =>
      req.eDepartment.toLowerCase().includes("nội bài")
    );
  }

  return requests.filter(
    (req) => !req.eDepartment.toLowerCase().includes("nội bài") && !req.eDepartment.toLowerCase().includes("đà nẵng") 
  );
};